export const main_menu = "منوی اصلی"
export const dashboard = "داشبورد"
export const setting = "تنظیمات"
export const account = "حساب کاربری"
export const login_to_account = "ورود به حساب"
export const force_logout = "پاک کردن کش"
export const logout_from_account = "خروج از حساب"
export const logout_from_account_description = "آیا مایلید از حساب کاربری خود خارج شوید؟"
export const not_found_description = `صفحه ای که به دنبال آن هستید ممکن است حذف شده باشد،\nنامش تغییر کرده باشد یا موقتا در دسترس نباشد.`
export const not_found = "404 - صفحه یافت نشد"
export const oops = "اوپس!"
export const please_login = "برای دسترسی به سامانه وارد حساب خود شوید"
export const login_with_mobile = "ورود با موبایل"
export const mobile_is_not_valid = "موبایل وارد شده صحیح نیست"
export const mobile = "موبایل"
export const error_dots = "ارور: "
export const title = "عنوان"
export const title_fa = "عنوان فارسی"
export const title_en = "عنوان انگلیسی"
export const enter_your_mobile ="موبایل خود را وارد کنید"
export const confirm = "تایید"
export const code_sent_prefix = "کد تایید به "
export const code_sent_suffix = " ارسال شد"
export const confirmation_code = "کد تایید"
export const users = "کاربران"
export const select_category = "انتخاب دسته بندی"
export const see_more = "مشاهده بیشتر"
export const deleted = "با موفقیت حذف شد"
export const new_item = "جدید"
export const count_title = "تعداد "
export const search = "جستجو"
export const yes = "بله"
export const no = "خیر"
export const field_register_at = "ثبت نام"
export const field_purchase_count = "تعداد خرید"
export const delete_modal_title = "حذف"
export const delete_modal_description = ".آیا مایلید آیتم انتخابی حذف شود؟ این عملیات قابل برگشت نیست"
export const field_platform = "پلتفرم"
export const order = "مرتب سازی"
export const orderType = "ترتیب"
export const clear = "پاک کردن"
export const list_filters = "فیلترها"
export const date_hint = "0000/00/00"
export const configurations = "کانفیگ ها"
export const folders = "فولدرها"
export const releases = "ریلیزها"
export const file_servers = "سرورهای فایل"
export const system_management = "مدیریت سیستم"
export const content_management = "مدیریت محتوا"
export const categories = "دسته بندی ها"
export const add = "افزودن"
export const add_item = "افزودن "
export const edit_item = "ویرایش "
export const view_item = "مشاهده "
export const key = "کلید"
export const value = "مقدار"
export const edit = "ویرایش"
export const save = "ذخیره"
export const saved = "با موفقیت اضافه شد"
export const delete_ = "حذف"
export const updated = "با موفقیت آپدیت شد"
export const register_time = "تاریخ ثبت نام"
export const insert_time = "تاریخ ثبت"
export const path = "مسیر"
export const insert_by = "کاربر ثبت کننده"
export const update_by = "کاربر ویرایش کننده"
export const last_update_at = "تاریخ آخرین ویرایش"
export const username = "نام کاربری"
export const user_role = "نقش کاربری"
export const field_make_admin = "تبدیل به مدیر"
export const field_remove_admin = "تبدیل به کاربر عادی"
export const field_permissions = "دسترسی ها"
export const recreate_god = "بازسازی سوپرادمین"
export const successfully_done = "با موفقیت انجام شد"
export const address = "آدرس"
export const address_multiple = "آدرس | address"
export const tag_multiple = "تگ | tag"
export const port_multiple = "پورت | port"
export const route_multiple = "روت | route"
export const password = "رمز عبور"
export const tag = "تگ"
export const file_server = "سرور"
export const search_hint = "جستجو کنید"
export const select_something = "انتخاب کنید"
export const pick = "انتخاب کنید"
export const pick_category_or_root = "بدون دسته بندی (انتخاب کنید)"
export const gallery_pictures = "گالری تصاویر"
export const field_picture = "تصویر"
export const select_picture = "انتخاب تصویر"
export const uploading_file_panel_to_back = "آپلود از کامپیوتر شما به سرور"
export const uploading_file_back_to_file_server = "در حال آپلود از سرور به فایل سرور اصلی، منتظر بمانید"
export const upload = "آپلود"
export const please_wait = "لطفا منتظر بمانید"
export const select_file = "انتخاب فایل"
export const selected_file = "فایل انتخاب شده"
export const select_picture_from_gallery = "گالری تصاویر"
export const parent_category = "دسته بندی والد"
export const order_in_parent = "ترتیب در والد"
export const category = "دسته بندی"
export const active = "فعال"
export const deactive = "غیرفعال"
export const description = "توضیحات"
export const version_name = "نام نسخه"
export const version_code = "کد نسخه"
export const is_test_release = "نسخه تست"
export const extra_info = "اطلاعات اضافه"
export const tasks = "تسک ها"
export const tasks_done_in_last_release = "تسک های انجام شده"
export const files = "فایل ها"
export const task_code = "شماره"
export const task_title = "عنوان"
export const team = "تیم"
export const task = "تسک"
export const links = "لینک ها"
export const link = "لینک"
export const rolled_back = "لغو شده"
export const wepod_console = "کنسول ویپاد"
export const pleaase_wait = "لطفا منتظر بمانید"
export const no_information_found = "اطلاعاتی وجود ندارد"
export const last_test_version = "آخرین نسخه تستی"
export const download_it = "فایل ها"
export const download = "دانلود"
export const check_it = "لینک ها"
export const check = "مشاهده"
export const in_date = "در تاریخ"
export const last_public_release = "آخرین ریلیز عمومی"
export const extra_information = "اطلاعات بیشتر"
export const detail = "جزییات"
export const download_guide = "جهت دانلود، روی لینک ها انگشت خود را نگه دارید و Open in new tab یا Save link را انتخاب کنید."
export const test_version_details = "مشخصات نسخه تستی"
export const public_version_details = "مشخصات نسخه ریلیز"
export const check_all_releases = "بیشتر >"
export const test_version = "نسخه تستی"
export const public_version = "نسخه ریلیز"
export const clear_filter = "ریست فیلتر"
export const no_item_found = "نتیجه ای یافت نشد."
export const included_releases = "نسخه های تستی که در این ریلیز وجود دارد"
export const show_release_note = "مشاهده ریلیزنوت"
export const useful_links = "لینکهای پرکاربرد"
export const permission_required = "نیازمند دسترسی"
export const i_have_permission = "دسترسی مورد نیاز را دارم"




